import { AccountVerificationRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAccountVerification() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  async function fetchAccountVerification(req: AccountVerificationRequest) {
    try {
      setFetching(true);

      const res = await api.fetchAccountVerification(req);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setTotalRecords(res.PaginationMetaData?.TotalRecords || 0);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchAccountVerification, totalRecords };
}
